import { ofType } from "redux-observable";
import { mapTo, tap } from "rxjs/operators";
import { IdPersistence } from "../../../../constants/IdPersistence";
import { selectVisitedQuests } from "../../../../selectors/selectVisitedQuests";
import { PersistenceMode } from "../../../../utils/PersistenceMode";
import { utilPersistence } from "../../../../utils/utilPersistence";
import { actionModalClose } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionQuest } from "../list/actionQuests";
export var epicQuestVisited = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuest.Visited), tap(function (action) {
        var visitedQuestIntroIds = selectVisitedQuests();
        visitedQuestIntroIds.add(action.questId);
        utilPersistence.setValue(IdPersistence.QuestIntro, {
            visitedQuestIntroIds: visitedQuestIntroIds,
        }, PersistenceMode.Write);
    }), mapTo(actionModalClose(IdModal.QuestIntros)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestVisited.ts
// module id = 1972
// module chunks = 3